import {
  CDN,
  CURRENCY,
  DOMAIN,
  DOMAIN_PUBLIC,
  LOCALE,
  MERCHANT,
  MONGO_API,
  PATHNAME,
  TYPE_ACCESORIO,
  TYPE_EQUIPO,
  TYPE_PLAN,
  TYPE_POSPAGO,
} from '~/store/States/global';

export async function getProduct(group) {
  const res = await fetch(`${DOMAIN}${MONGO_API}${MERCHANT}/product/${group}?lang=${LOCALE}&currency=${CURRENCY}`);
  if (res.ok) {
    return res.json();
  }
  console.error('Error getProduct', res);
  return null;
}

export function ordenarGrupo(producto) {
  producto.items = producto.items.filter(it => it.available).sort((it1, it2) => {
    if (it1.position < it2.position) {
      return -1;
    } else if (it1.position > it2.position) {
      return 1;
    }
    return it1.pricing[process.env.NEXT_PUBLIC_CURRENCY].offer_price - it2.pricing[process.env.NEXT_PUBLIC_CURRENCY].offer_price;
  });
}

export function mapaAtributos(attributes) {
  return attributes.reduce((obj, attribute) => {
    obj[attribute.identifier] = attribute.value;
    return obj;
  }, {});
}

export function pricingPospago(planDef, plazoDef, itemPricing, pricing, planes) {
  if (planDef && (!planes || planes[planDef]) && itemPricing[pricing]?.[planDef]) {
    const plan = itemPricing[pricing][planDef];
    plan.plan = planDef;
    return plan;
  }
  return itemPricing[pricing]?.[
    Object.keys(itemPricing[pricing])
      .filter((pl) => {
        if (planes) {
          if (planes[pl]) {
            itemPricing[pricing][pl].plan = pl;
            return true;
          }
          return false;
        }
        itemPricing[pricing][pl].plan = pl;
        return true;
      })
      .sort((p1, p2) => {
        let pl1 = plazoDef;
        if (!pl1 || !itemPricing[pricing][pl1]) {
          pl1 = Object.keys(itemPricing[pricing][p1]).sort((a, b) => b - a)[0];
        }
        let pl2 = plazoDef;
        if (!pl2 || !itemPricing[pricing][pl2]) {
          pl2 = Object.keys(itemPricing[pricing][p2]).sort((a, b) => b - a)[0];
        }
        return itemPricing[pricing][p1][pl1].offer_price - itemPricing[pricing][p2][pl2].offer_price;
      })[0]
    ];
}

export async function richSnippet(seoname, group) {
  const product = await getProduct(group);
  if (!product || !product.length) {
    return null;
  }
  try {
    const parent = product[0];
    ordenarGrupo(parent);
    const item = parent.items[0];
    if (!item) {
      return null;
    }
    const attrMap = mapaAtributos(item.attributes);
    const name =
      attrMap['attr-rich-snippet-name'] || item.locales[LOCALE].name.replace(/\\n/g, '').replace(/\s+/g, ' ');
    const description = attrMap['attr-rich-snippet-description'] || name;
    const image = `${CDN}${item.images[0]?.replace('.jpg', '_312x400.jpg') ?? ''}`;
    const brand = attrMap['filt-marca'] || (item.locales[LOCALE].categories.find((x) => x.level === 3)?.name ?? '');
    let price = (item.pricing?.[CURRENCY]?.offer_price || 0) / 100;
    const priceCurrency = CURRENCY.toUpperCase();
    const priceValidUntil = attrMap['attr-rich-snippet-price-valid-until'];

    let urlproduct = 'product';

    switch (item.type) {
      case TYPE_PLAN:
        price = +(attrMap['attr-conf-precio-mensual'] || 0);
        break;
      case TYPE_EQUIPO:
      case TYPE_ACCESORIO:
        urlproduct = 'productx';
        break;
      case TYPE_POSPAGO:
        urlproduct = 'productp';
        const attrDefaultPlan = attrMap['attr-conf-default-plan']?.replace(/\./g, '_') || '';
        const plazo = attrMap['attr-conf-default-plazo'];
        const prices = pricingPospago(attrDefaultPlan, plazo, item.pricing, 'pospago');
        if (prices) {
          let first = plazo;
          if (!first || !prices[first]) {
            first = Object.keys(prices).sort((a, b) => b - a)[0];
          }
          price = prices[first].offer_price;
        }
        break;
    }

    const url = `${DOMAIN_PUBLIC}${PATHNAME}/${urlproduct}/${seoname}/${group}`;

    const jsonLd = {
      '@context': 'https://schema.org',
      '@type': 'Product',
      name,
      description,
      image,
      brand: {
        '@type': 'Brand',
        name: brand,
      },
      url,
      offers: {
        '@type': 'Offer',
        price: price.toFixed(2),
        priceCurrency,
        availability: 'https://schema.org/InStock',
      },
    };

    if (priceValidUntil) {
      jsonLd.offers.priceValidUntil = priceValidUntil;
    }
    return jsonLd;
  } catch (e) {
    console.error('Error richSnippet:', seoname, group, e);
    return null;
  }
}
